import { request } from '@vtx/utils';
import http from './request.js';

export const getStaffPageData = id => async ({ current, pageSize }, formData) => {
    const body = {
        ...formData,
        companyId: id,
        page: current - 1,
        size: pageSize,
    };
    let list = [];
    let total = 0;
    const res = await request.get(`/cloud/gas/api/v1/gasStaff/page`, {
        body,
    });
    if (res?.result === 0) {
        if (Array.isArray(res.data?.rows)) {
            list = res.data.rows.map(item => ({
                ...item,
                key: item.id,
            }));
            total = res.data.total;
        }
    }
    return {
        list,
        total,
    };
};

export const getInfo = async (id, urlHead) => {
    const res = await http.get(`/cloud/${urlHead ? urlHead : 'gas'}/api/v1/gasCompany/get`, {
        body: { id },
        desensitized: true
    });
    if (res?.result === 0) {
        return res?.data;
    }
    return {};
};

export const getUserPageData = (id, urlHead) => async ({ current, pageSize }, formData) => {
    const body = {
        ...formData,
        supplyCompanyId: id,
        page: current - 1,
        size: pageSize,
    };
    let list = [];
    let total = 0;
    const res = await request.get(`/cloud/${urlHead ? urlHead : 'gas'}/api/v1/gasUser/page`, {
        body,
    });
    if (res?.result === 0) {
        if (Array.isArray(res.data?.rows)) {
            list = res.data.rows.map(item => ({
                ...item,
                key: item.id,
            }));
            total = res.data.total;
        }
    }
    return {
        list,
        total,
    };
};

export const getBottlePageData = (id, urlHead) => async ({ current, pageSize }, formData) => {
    const body = {
        ...formData,
        gasCompanyId: id,
        page: current - 1,
        size: pageSize,
    };
    let list = [];
    let total = 0;
    const res = await request.get(`/cloud/${urlHead ? urlHead : 'gas'}/api/v1/bottleInfo/pageList`, {
        body,
    });
    if (res?.result === 0) {
        if (Array.isArray(res.data?.rows)) {
            list = res.data.rows.map(item => ({
                ...item,
                key: item.id,
            }));
            total = res.data.total;
        }
    }
    return {
        list,
        total,
    };
};

export const getSiteList = (id, code) => async ({ current, pageSize }) => {
    const body = {
        page: current - 1,
        coordType: 'bd09',
        size: pageSize,
        code,
        parameters: {
            affiliatedEnterpriseId: id,
        },
    };
    let list = [];
    let total = 0;
    const res = await request.get(`/cloud/jcss-reborn/facility/page`, {
        body,
    });
    if (res?.result === 0) {
        if (Array.isArray(res.data?.rows)) {
            list = res.data.rows.map(item => ({
                ...item,
                key: item.id,
            }));
            total = res.data.total;
        }
    }
    return {
        list,
        total,
    };
};
